<template>
  <div class="container">
    <div id="columnMain" class="mb-3">
      <div id="columnMainContent">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 char-block" v-for="char in chars">
            <div class="row">
              <div class="col char-char">{{ char.char }}</div>
              <div class="col char-trans">{{ char.trans }}</div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6 char-block">
            <div class="row">
              <div class="col char-char">ّ</div>
              <div class="col char-trans">zdvojeně</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        'chars': [
          {
            char: 'َا',
            trans: 'á'
          },
          {
            char: 'ب',
            trans: 'b'
          },
          {
            char: 'ت',
            trans: 't'
          },
          {
            char: 'ث',
            trans: 'th'
          },
          {
            char: 'ج',
            trans: 'dž'
          },
          {
            char: 'ح',
            trans: 'h'
          },
          {
            char: 'خ',
            trans: 'ch'
          },
          {
            char: 'د',
            trans: 'd'
          },
          {
            char: 'ذ',
            trans: 'dh'
          },
          {
            char: 'ر',
            trans: 'r'
          },
          {
            char: 'ز',
            trans: 'z'
          },
          {
            char: 'س',
            trans: 's'
          },
          {
            char: 'ش',
            trans: 'š'
          },
          {
            char: 'ص',
            trans: 's'
          },
          {
            char: 'ض',
            trans: 'd'
          },
          {
            char: 'ط',
            trans: 't'
          },
          {
            char: 'ظ',
            trans: 'z'
          },
          {
            char: 'ع',
            trans: '‘'
          },
          {
            char: 'غ',
            trans: 'gh'
          },
          {
            char: 'ف',
            trans: 'f'
          },
          {
            char: 'ق',
            trans: 'q'
          },
          {
            char: 'ک',
            trans: 'k'
          },
          {
            char: 'ل',
            trans: 'l'
          },
          {
            char: 'م',
            trans: 'm'
          },
          {
            char: 'ن',
            trans: 'n'
          },
          {
            char: 'و',
            trans: 'w'
          },
          {
            char: 'ه',
            trans: 'h'
          },
          {
            char: 'ي',
            trans: 'j'
          },
          {
            char: 'ء',
            trans: '´'
          },
          {
            char: 'ُ ',
            trans: 'u'
          },
          {
            char: 'ِ',
            trans: 'i'
          },
          {
            char: 'َ ',
            trans: 'a'
          },
          {
            char: 'ِي',
            trans: 'í'
          },
          {
            char: 'ُو',
            trans: 'ú'
          }
        ]
      }
    }
  };
</script>
<style lang="scss" scoped>
  $global_color: #4c709b;
  // $global_color: rgba(66, 130, 62, 1);

  #columnMain {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;

    .boxTopRight {
      text-align: right;
    }

    #columnMainContent {
      padding: 5px 10px 5px 10px;
      font-size: 12px;
      line-height: 18px;

      #statusContainer {
        position: absolute;
        z-index: 2;
        width: 830px;
        top: 120px;
        margin: 0 auto;
        display: none;

        #status {
          width: 215px;
          padding: 30px;
          border: 2px solid #7EA9D3;
          margin: 0 auto;
          font-size: 16px;
          color: #619AD9;
          font-weight: bold;
          background-image: url('../../assets/images/loadingBox.jpg');
          background-repeat: no-repeat;
        }
      }

      #quranIndex {
        min-height: 580px;
        padding: 5px 0px 0px 0px;

        h3 {
          font-size: 12px;
          font-weight: bold;
          margin: 0px;
        }

        .surahColumn {
          line-height: 30px;
          font-size: 13px;
          font-family: "trebuchet ms", Arial, Helvetica, sans-serif;
          padding: 0px 15px;

          &:first-child {
            padding-left: 0px;
          }

          a {
            .div {
              padding: 10px 10px 10px 10px;
              text-decoration: none;
              color: #666;
              border-bottom: 2px solid transparent;

              &:hover {
                background-color: rgba(192, 192, 192, 0.3);
                // border-bottom: 2px solid rgba(66, 130, 62, 1);
                border-bottom: 2px solid $global_color;
                // color: rgba(66, 130, 62, 1);
                color: $global_color;
              }

              .pl-1 {
                div:first-child {
                  padding-right: 10px;
                }
                div:last-child {
                  padding-left: 10px;
                }
              }
            }
          }

          &:last-child {
            padding-right: 0px;
          }
        }
      }
    }

    .char-block {
      padding: 2rem;
    }

    .char-char {
      margin-right: 4px;
    }

    .char-trans {
      background: #dadada;
    }

    .char-char, .char-trans {
      padding: 2rem;
      font-size: 3rem;
      border: 1px solid #525f7f;
      text-align: center;
      border-radius: 10px;
    }


  }
</style>